// abortSignalTimeout and abortSignalAny were copied from the following polyfill module:
// https://github.com/mo/abortcontroller-polyfill/commit/78cced84dadd0ce022e1f2cf5bb7f52dc8cbffeb
// These functions are not supported in all of the last 4 versions of Safari
export function abortSignalTimeout(milliseconds: number): AbortSignal {
  if (typeof AbortSignal.timeout === 'function') {
    return AbortSignal.timeout(milliseconds);
  }
  const controller = new AbortController();

  setTimeout(
    () =>
      controller.abort(
        new DOMException(
          `This signal is timeout in ${milliseconds}ms`,
          'TimeoutError',
        ),
      ),
    milliseconds,
  );

  return controller.signal;
}
export function abortSignalAny(iterable: AbortSignal[]): AbortSignal {
  if (typeof AbortSignal.any === 'function') {
    return AbortSignal.any(iterable);
  }
  const controller = new AbortController();
  // added this: any parameter to stop TypeScript from complaining
  function abort(this: any): void {
    controller.abort(this.reason);
    clean();
  }
  function clean(): void {
    for (const signal of iterable) {
      signal.removeEventListener('abort', abort);
    }
  }
  for (const signal of iterable) {
    if (signal.aborted) {
      controller.abort(signal.reason);
      break;
    } else {
      signal.addEventListener('abort', abort);
    }
  }

  return controller.signal;
}
